var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-gray-50 px-6 py-5 flex justify-between" },
    [
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c(_vm.cardName, {
            tag: "component",
            staticClass: "sm:mr-4 w-16 h-10",
          }),
          _c("div", [
            _c(
              "div",
              { staticClass: "text-sm leading-5 font-medium text-gray-900" },
              [_vm._v(" Ending with " + _vm._s(_vm.last4) + " ")]
            ),
            _c(
              "div",
              {
                staticClass:
                  "mt-1 text-sm leading-5 text-gray-600 sm:flex sm:items-center",
              },
              [
                _vm.isExpired
                  ? _c("p", { staticClass: "text-red-600" }, [
                      _vm._v(" Expired " + _vm._s(_vm.expiresDate) + " "),
                    ])
                  : _c("p", [
                      _vm._v(" Expires " + _vm._s(_vm.expiresDate) + " "),
                    ]),
                _c(
                  "span",
                  {
                    staticClass: "hidden sm:mx-2 sm:inline",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v(" · ")]
                ),
                _c("div", { staticClass: "mt-1 sm:mt-0" }, [
                  _vm._v("Added on " + _vm._s(_vm.formattedUpdatedAt)),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "flex items-center" },
        [_vm._t("actions", null, { isExpired: _vm.isExpired })],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }